export const calcSegmentsWithPoints = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/calcSegmentsWithPoints', params);
        },
    };
};
